import { useI18n } from "#hooks/use-i18n"
import { useTour } from "@reactour/tour"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { Button } from "../ui/button"

interface TourNavigationProps {
  onSkip?: () => void | Promise<void>
}

export function TourNavigation({ onSkip }: TourNavigationProps) {
  const { t } = useI18n()
  const { currentStep, setCurrentStep, setIsOpen, steps } = useTour()
  const totalSteps = steps?.length || 0
  const isFirstStep = currentStep === 0
  const isLastStep = currentStep === totalSteps - 1

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1)
    }
  }

  const handleNext = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1)
    }
  }

  const handleSkip = async () => {
    if (onSkip) {
      await onSkip()
    }
    setIsOpen(false)
  }

  return (
    <div className="flex justify-between gap-3 mt-4 pt-4 border-t border-border">
      <div className="flex items-center justify-center">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleSkip}
          className="text-muted-foreground hover:text-foreground"
        >
          {t("components.tour.skipTour")}
        </Button>
      </div>

      <div className="flex items-center justify-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={handlePrevious}
          disabled={isFirstStep}
          className="h-8 w-8 p-0"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="text-xs text-muted-foreground min-w-[3rem] text-center">
          {currentStep + 1} / {totalSteps}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={handleNext}
          disabled={isLastStep}
          className="h-8 w-8 p-0"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
